import { Form, InputNumber } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { isRequiredField } from '../../../utilz';
import { routeFileSelector } from '../../../utilz/i18n';

const FormInputNumber = ({
  placeholder = false,
  label,
  editMode = false,
  forFilter = false,
  margin = 'mb-15',
  singleLineMode = false,
  name = `testFiled-${Math.random()}`,
  rules = [],
  colon = false,
  inverMode = false,
  disabled,
  onBlur,
  className = '',
  inputType = 'text',
  onChange = false,
  defaultValue,
  readOnly = false,
  minValue = 0,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <>
      <Form.Item
        className={`form-number-input-container ${inverMode ? 'invert-mode' : ''} ${margin} ${
          singleLineMode ? 'single-line-mode' : ''
        } form-input-container ${!editMode ? 'edit-mode-off' : ''} ${className}`}
        name={name}
        rules={rules}
        label={
          <>
            {label}
            {rules.length > 0 && isRequiredField(rules) && <span className="required">*</span>}
          </>
        }
        labelCol={10}
        colon={colon}
      >
        <InputNumber
          disabled={disabled}
          readOnly={readOnly ? readOnly : !editMode}
          placeholder={
            editMode ? (placeholder ? placeholder : `${t('translation:default.fields.enter')} ${label}`) : ''
          }
          className={`${forFilter ? 'filter-input' : 'form-input'} `}
          {...(onBlur ? { onBlur } : {})}
          type={inputType}
          {...(onChange ? { onChange } : {})}
          defaultValue={defaultValue}
          min={minValue}
          id={name}
          decimalSeparator="."
        />
      </Form.Item>
    </>
  );
};

export default FormInputNumber;
